import React, { useEffect } from "react";
import { renderElement } from "../../../../Components/Common/FormRendererV2/Renderer";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Form } from "react-bootstrap";
import { CardBody } from "reactstrap";
import {
  resetFormState,
  setSelectValidError,
  verifyModal,
} from "../../../../slices/common/reducer";
import CommonButton from "../../../../Components/Common/CommonButton/CommonButton";
import { OemModalLayoutJSON } from "../Json/OemLayoutJson";
import HubDocuments from "../../../../Components/Common/Documents/HubDocuments";
import ConfirmationModal from "../Modal/ConfirmationModal";
import { useState } from "react";
import { getOemData, updateOem } from "../OemService";
import { checkButtonAccess } from "../../../../Utils/CommonUtils";

const Details = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigator = useNavigate();
  const formState = useSelector((state) => state.common.formRendererState);
  const verifyShow = useSelector((state) => state.common.verifyShow);
  const triggerRender = useSelector((state) => state.common.triggerRender);
  const oemFieldJson = useSelector((state) => state.oem.oemFieldJson);
  const data = useSelector((state) => state.oem.selectedOem.detailsData);
  const editMode = !!params.id;
  const [isEditing, setIsEditing] = useState({});
  const [filesFetched, setFilesFetched] = useState(false);
  const files = useSelector(
    (state) => state.oem.selectedOem.detailsData.file || {}
  );

  useEffect(() => {
    if (params.id) {
      getOemData(params.id, "OEM");
    }
  }, [params.id]);

  const handleCancel = () => {
    dispatch(resetFormState());
    dispatch(setSelectValidError(false));
    navigator("/prod/oem");
  };

  const updateClickHandler = (e) => {
    e.preventDefault();
    dispatch(verifyModal(true));
  };

  const confirmUpdate = () => {
    if (formState) {
      dispatch(setSelectValidError(false));
      updateOem(formState, params.id, "OEM", navigator);
    } else {
      dispatch(setSelectValidError(true));
    }
    dispatch(verifyModal(false));
  };

  const toggleEdit = (fieldKey) => {
    setIsEditing((prev) => ({
      ...prev,
      [fieldKey]: !prev[fieldKey],
    }));
  };

  return (
    <div>
      <Form onSubmit={updateClickHandler}>
        <CardBody>
          <div className="selected-tab-bottom-content">
            {/* {OemModalLayoutJSON.map((section) => (
              <div key={section.elementid}>
                {section.child.map((columns) => (
                  <div key={columns.elementid} className="row">
                    {columns.child.map((column) => renderField(column))}
                  </div>
                ))}
              </div>
            ))} */}
            {OemModalLayoutJSON.map((element) => (
              <div key={element.elementid}>
                {element.child.map((child) =>
                  renderElement(child, oemFieldJson, formState)
                )}
              </div>
            ))}
          </div>
          <div className="form-footer">
            <CommonButton
              update={true}
              // handleSubmit={updateClickHandler}
              handleCancel={handleCancel}
              checkAccess={checkButtonAccess("EDIT", "PROD_OEM")}
            />
          </div>
          {verifyShow && <ConfirmationModal confirmUpdate={confirmUpdate} />}
        </CardBody>
      </Form>

      {/* </form> */}
    </div>
  );
};

export default Details;
